export default __webpack_public_path__ + "static/media/svenska_foder.25415ba0.jpg";